import React from 'react';
import styled from 'styled-components';
import { isNil, startCase } from 'lodash-es';
import TableRow from '../TableRow';
import TableCell from '../TableCell';
const StyledContainer = styled.div ``;
const StyledRow = styled(TableRow) `
  border-bottom-color: ${({ theme }) => theme.ThemeColors.DARK_BORDER.hex};
`;
// TODO: DRY! This should be implemented by `TableRow`.
const StyledHeaderCellWrapper = styled.div `
  display: flex;
  align-items: center;
  padding: 0 0.666666667rem;
  box-sizing: border-box;
`;
const StyledCell = styled(TableCell) `
  font-weight: 700;
`;
const renderHeaderCells = (columns, onCellClick, headerCellClassName) => columns.map(({ name, headerLabel, headerCellComponent: HeaderCell = StyledCell, headerCellComponentExtraProps = {}, width, style, }) => {
    const label = !isNil(headerLabel) ? headerLabel : startCase(name);
    return (
    // TODO: DRY! This should be implemented by `TableRow`.
    React.createElement(StyledHeaderCellWrapper, { style: Object.assign({ flex: `1 ${width}` }, style) },
        React.createElement(HeaderCell, Object.assign({ className: headerCellClassName, name: name, value: label, onClick: onCellClick, width: width }, headerCellComponentExtraProps))));
});
const TableHeader = ({ columns, className, headerRowClassName, headerCellClassName, onCellClick, style, }) => (React.createElement(StyledContainer, { className: className },
    React.createElement(StyledRow, { className: headerRowClassName, style: style }, renderHeaderCells(columns, onCellClick, headerCellClassName))));
export default TableHeader;
